module.exports = __webpack_public_path__ + "static/media/slicedpomegranate.ee7ef4e5.webp";